import { DAY_IN_MINUTES, HOUR_IN_MINUTES } from '@common/definitions';
import createTempId from '@common/utils/create-temp-id';
import { NotificationType } from '@modules/events/forms/event/notifications-input';

export const getNewEntry = (
  value: NotificationType['value'],
  unit: NotificationType['unit']
) => {
  return { id: createTempId(), value, unit };
};

export const getInitValue = (intervals: null | number[]) => {
  if (Array.isArray(intervals)) {
    return intervals.filter((value) => typeof value === 'number').map((n) => {
      const days = n / DAY_IN_MINUTES;
      if (Number.isInteger(days)) {
        return getNewEntry(days.toString(), 'days');
      }
      const hours = n / HOUR_IN_MINUTES;
      if (Number.isInteger(hours)) {
        return getNewEntry(hours.toString(), 'hours');
      }
      return getNewEntry(n.toString(), 'minutes');
    });
  }
  return [];
};
